module.exports = __webpack_public_path__ + "static/images/coupon-card-bg.9fb919e.png";